import config from 'config/Config';
import BaseApi from './BaseApi';
import { FormSummary } from 'types/store/normalized';

export class FormSummariesApi extends BaseApi<FormSummary> {
  constructor() {
    super(`${config.get('backendURL')}v2/form-summaries`);
  }
}
